export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getMyConsentRequests({ rootGetters }, params) {
      return rootGetters.api.get('/user/my-consent-requests', { params })
        .then((response) => response.data);
    },
    createConsent({ rootGetters }, params) {
      return rootGetters.api.post('/consents/create', { params })
        .then((response) => response.data);
    },
    recreateConsent({ rootGetters }, consentId) {
      return rootGetters.api.post('/consents/'+consentId+'/recreate')
        .then((response) => response.data);
    },
    buyConsent({ rootGetters }, consentId) {
      return rootGetters.api.post('/consents/'+consentId+'/buy')
        .then((response) => response.data);
    },
  },
};
